
export enum FmsSecCntr {
    // OIM
    OIMblHold = "OI_MBL_Hold",

    // OIH
    OIHblNomi = "OI_HBL_Nomi",
    OIHblFree = "OI_HBL_Free",
    OIHblCoLoad = "OI_HBL_CoLoad",
    OIHblExpressRelease = "OI_HBL_ExpressRelease",
    OIHblOBLReceived = "OI_HBL_OBLReceived",
    OIHblOBLReceivedDate = "OI_HBL_OBLReceivedDate",
    OIHblReleased = "OI_HBL_Released",
    OIHblReleasedBy = "OI_HBL_ReleasedBy",
    OIHblReleasedDate = "OI_HBL_ReleasedDate",
    OIHblSalesperson = "OI_HBL_Salesperson",

    // OEH
    OEHblSalesperson = "OE_HBL_Salesperson",

    // AIH
    AIHblSalesperson = "AI_HAWB_Salesperson",

    // AEH
    AEHblSalesperson = "AE_HAWB_Salesperson",

    // Other Shipment
    OtherShipmentSalesperson = "OtherShipment_Salesperson",

    // General Invoice
    GInvGiveCredit = "GInv_GiveCredit",
    GInvCancelCredit = "GInv_CancelCredit",
    GInvConfirmed = "GInv_Confirmed",
    GInvDraft = "GInv_Draft",

    //Storage Invoice
    STInvConfirmed = "STInv_Confirmed",

    // Invoice
    InvGivCredit = "Inv_GiveCredit",
    InvCancelCredit = "Inv_CancelCredit",
    InvConfirmed = "Inv_Confirmed",
    InvDraft = "Inv_Draft",

    // General Bill
    GBillGivCredit = "GBill_GiveCredit",
    GBillCancelCredit = "GBill_CancelCredit",
    GBillConfirmed = "GBill_Confirmed",
    GBillDraft = "GBill_Draft",

    // Bill
    BillGivCredit = "Bill_GiveCredit",
    BillCancelCredit = "Bill_CancelCredit",
    BillConfirmed = "Bill_Confirmed",
    BillDraft = "Bill_Draft",

    // Crdb
    CrDbConfirmed = "CrDb_Confirmed",


    //warehousing
    WHInvConfirmed = "WHInv_Confirmed",
	WHBillConfirmed = "WHBill_Confirmed",
	WHCrDbConfirmed = "WHCrDb_Confirmed",
    WHInvDraft = "WHInv_Draft",
    WHBillDraft = "WHBill_Draft",
    WHCrDbDraft = "WHCrDb_Draft",

    // Company
    ComAutoBillingRate = "Com_AutoBillingRate",
    ComCreditLimit = "Com_CreditLimit",
    ComCreditTerms = "Com_CreditTerms",
    ComCustomerServiceRep = "Com_CustomerServiceRep",
    ComSalesperson = "Com_SalesPerson",
    ComCreditHold = "Com_CreditHold",
    ComFullName = "Com_FullName",
    ComInactive = "Com_Inactive",
    ComShortName = "Com_ShorName",

    // Tool
    MemoEdit = "Memo_Edit",
    MemoDelete = "Memo_Delete",

    // Orchid
    ManifestDraft = "Manifest_Draft",
    LoadDraft = "Load_Draft",
    LocalDODraft = "LocalDO_Draft",
    
}
